"use client";
import { createContext } from "../../utils/create-context.js";
//#region src/components/fieldset/use-fieldset-context.ts
var [FieldsetProvider, useFieldsetContext] = createContext({
	name: "FieldsetContext",
	hookName: "useFieldsetContext",
	providerName: "<FieldsetProvider />",
	strict: false
});
//#endregion
export { FieldsetProvider, useFieldsetContext };
